var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal custom-modal fade",
      attrs: { id: "import_form", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered modal-lg",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [_vm._v("Import Link")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "dismisModal",
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-md-12",
                          staticStyle: { "margin-bottom": "20px" }
                        },
                        [
                          _c("div", { staticClass: "text-right" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn add-btn",
                                attrs: {
                                  href: _vm.excelTemplate,
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-download" }),
                                _vm._v(" Download Template\n                  ")
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.hideUpForm == false
                        ? [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-6" }, [
                                  _c("div", { staticClass: "form-group row" }, [
                                    _vm._m(0),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-8" },
                                      [
                                        _c(
                                          "multiselect",
                                          {
                                            attrs: {
                                              id: "ajax",
                                              label: "name",
                                              "track-by": "id",
                                              placeholder:
                                                "Type to search Brand...",
                                              multiple: true,
                                              "open-direction": "bottom",
                                              "custom-label": _vm.customLabel,
                                              options: _vm.contactOptions,
                                              searchable: true,
                                              loading: _vm.isLoading,
                                              "internal-search": false,
                                              "close-on-select": false,
                                              "options-limit": 300,
                                              limit: 3,
                                              "limit-text": _vm.limitText,
                                              "max-height": 600,
                                              "show-no-results": true,
                                              "hide-selected": true,
                                              "show-labels": false
                                            },
                                            on: {
                                              "search-change": _vm.asyncFind
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "tag",
                                                  fn: function(ref) {
                                                    var option = ref.option
                                                    var remove = ref.remove
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "custom__tag"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                option.name
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "custom__remove",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return remove(
                                                                    option
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("❌")]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "clear",
                                                  fn: function(props) {
                                                    return [
                                                      _vm.selectedContact.length
                                                        ? _c("div", {
                                                            staticClass:
                                                              "multiselect__clear",
                                                            on: {
                                                              mousedown: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                $event.stopPropagation()
                                                                return _vm.clearAll(
                                                                  props.search
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              2982222150
                                            ),
                                            model: {
                                              value: _vm.selectedContact,
                                              callback: function($$v) {
                                                _vm.selectedContact = $$v
                                              },
                                              expression: "selectedContact"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "noResult" },
                                                slot: "noResult"
                                              },
                                              [
                                                _vm._v(
                                                  "Oops! No elements found."
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-6" }, [
                                  _c("div", { staticClass: "form-group row" }, [
                                    _vm._m(1),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-8" },
                                      [
                                        _vm.selectedContact.length
                                          ? _c(
                                              "multiselect",
                                              {
                                                attrs: {
                                                  id: "ajax",
                                                  label: "name",
                                                  "track-by": "id",
                                                  placeholder:
                                                    "Type to search Product...",
                                                  multiple: true,
                                                  "open-direction": "bottom",
                                                  "custom-label":
                                                    _vm.customLabel,
                                                  options: _vm.productOptions,
                                                  searchable: true,
                                                  loading: _vm.isLoading,
                                                  "internal-search": false,
                                                  "close-on-select": false,
                                                  "options-limit": 300,
                                                  limit: 3,
                                                  "limit-text": _vm.limitText,
                                                  "max-height": 600,
                                                  "show-no-results": true,
                                                  "hide-selected": true,
                                                  "show-labels": false
                                                },
                                                on: {
                                                  "search-change":
                                                    _vm.asyncFindProduct
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "tag",
                                                      fn: function(ref) {
                                                        var option = ref.option
                                                        var remove = ref.remove
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "custom__tag"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    option.name
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "custom__remove",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return remove(
                                                                        option
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("❌")]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "clear",
                                                      fn: function(props) {
                                                        return [
                                                          _vm.selectedProduct
                                                            .length
                                                            ? _c("div", {
                                                                staticClass:
                                                                  "multiselect__clear",
                                                                on: {
                                                                  mousedown: function(
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    $event.stopPropagation()
                                                                    return _vm.clearAll(
                                                                      props.search
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1857285805
                                                ),
                                                model: {
                                                  value: _vm.selectedProduct,
                                                  callback: function($$v) {
                                                    _vm.selectedProduct = $$v
                                                  },
                                                  expression: "selectedProduct"
                                                }
                                              },
                                              [
                                                _vm._v(" "),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "noResult" },
                                                    slot: "noResult"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Oops! No elements found."
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _vm.formData.file
                                        ? _c(
                                            "ul",
                                            { staticClass: "upload-list" },
                                            [
                                              _c(
                                                "li",
                                                { staticClass: "file-list" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "upload-wrap"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "file-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                  " +
                                                              _vm._s(
                                                                _vm.formData
                                                                  .file.name
                                                              ) +
                                                              "\n                                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "file-size"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                  " +
                                                              _vm._s(
                                                                Math.round(
                                                                  _vm.formData
                                                                    .file.size /
                                                                    1000
                                                                ) + "kb"
                                                              ) +
                                                              "\n                                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "file-close"
                                                        },
                                                        [
                                                          _c("span"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "text-warning",
                                                              attrs: {
                                                                href: "#"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.removeFile(
                                                                    $event
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-trash-o"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.formData.file == ""
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "dropzone-container",
                                              on: {
                                                dragover: _vm.dragover,
                                                dragleave: _vm.dragleave,
                                                drop: _vm.drop
                                              }
                                            },
                                            [
                                              _c("input", {
                                                ref: "file",
                                                staticClass: "hidden-input",
                                                attrs: {
                                                  type: "file",
                                                  name: "file",
                                                  id: "fileInput",
                                                  accept:
                                                    "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                },
                                                on: {
                                                  change: _vm.onFileSelected
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "file-label",
                                                  attrs: { for: "fileInput" }
                                                },
                                                [
                                                  _vm.isDragging
                                                    ? _c("div", [
                                                        _vm._v(
                                                          "\n                                Release to drop files here.\n                              "
                                                        )
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          "\n                                Drop files here or "
                                                        ),
                                                        _c("u", [
                                                          _vm._v("click here")
                                                        ]),
                                                        _vm._v(
                                                          " to\n                                upload.\n                              "
                                                        )
                                                      ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "alert alert-warning",
                                          staticStyle: {
                                            "margin-bottom": "20px"
                                          }
                                        },
                                        [
                                          _c("ul", [
                                            _c("li", [
                                              _vm._v("Support files: xls, xlsx")
                                            ]),
                                            _vm._v(" "),
                                            _c("li", [_vm._v("MaxSize: 10mb")]),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                staticClass: "text text-danger"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                Mohon gunakan template yang disediakan agar\n                                data Anda dapat disimpan dengan benar.\n                              "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                staticClass: "text text-danger"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                Semua kolom wajib diisi.\n                              "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                staticClass: "text text-danger"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                Isi kolom "
                                                ),
                                                _c("b", [
                                                  _vm._v("marketplace")
                                                ]),
                                                _vm._v(
                                                  " dengan pilihan:\n                                "
                                                ),
                                                _vm._l(
                                                  _vm.dataListMarketplace,
                                                  function(row) {
                                                    return _c(
                                                      "span",
                                                      { key: row },
                                                      [
                                                        _vm._v(
                                                          _vm._s(row) +
                                                            ",\n                                "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                                Isi kolom "
                                                ),
                                                _c("b", [
                                                  _vm._v("status_value")
                                                ]),
                                                _vm._v(
                                                  " dengan pilihan:\n                                "
                                                ),
                                                _vm._l(
                                                  _vm.dataListMonitoringStatus,
                                                  function(row) {
                                                    return _c(
                                                      "span",
                                                      { key: row.id },
                                                      [
                                                        row.id == "raw" ||
                                                        row.id ==
                                                          "processing" ||
                                                        row.id == "closed"
                                                          ? [
                                                              _vm._v(
                                                                _vm._s(row.id) +
                                                                  ",\n                                  "
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                                Isi kolom "
                                                ),
                                                _c("b", [
                                                  _vm._v("product_image")
                                                ]),
                                                _vm._v(
                                                  " dan\n                                "
                                                ),
                                                _c("b", [_vm._v("screenshot")]),
                                                _vm._v(
                                                  " dengan link url,\n                                "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "Contoh: https://product_image.com\n                              "
                                                )
                                              ],
                                              2
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formData.file
                        ? _c(
                            "div",
                            {
                              staticClass: "col-md-12",
                              staticStyle: { "margin-bottom": "20px" }
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-md btn-secondary",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return (function() {
                                            return (_vm.hideUpForm = !_vm.hideUpForm)
                                          })($event)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.hideUpForm ? "Show" : "Hide"
                                          ) +
                                          " Form\n                    "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formData.file
                        ? _c(
                            "div",
                            {
                              staticClass: "col-md-12",
                              staticStyle: { "margin-bottom": "20px" }
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c("label", { staticClass: "col-md-12" }, [
                                  _vm._v(
                                    "\n                    Links Preview\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "table-responsive tabel-scroll-y"
                                    },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-striped custom-table mb-0"
                                        },
                                        [
                                          _vm._m(3),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            [
                                              _vm.previewLoading
                                                ? [
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            colspan: "7"
                                                          }
                                                        },
                                                        [
                                                          _c("Skeleton", {
                                                            attrs: { count: 1 }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ])
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.previewRows.length
                                                ? _vm._l(
                                                    _vm.previewRows,
                                                    function(row, index) {
                                                      return _c(
                                                        "tr",
                                                        { key: index },
                                                        [
                                                          row.product_url_err ||
                                                          row.mp_id == "" ||
                                                          row.store_name ==
                                                            "" ||
                                                          row.store_link ==
                                                            "" ||
                                                          row.product_name ==
                                                            "" ||
                                                          row.product_url ==
                                                            "" ||
                                                          row.product_price_start ==
                                                            "" ||
                                                          row.product_price_end ==
                                                            "" ||
                                                          row.product_image1 ==
                                                            "" ||
                                                          row.scraping_file_screenshot ==
                                                            "" ||
                                                          row.status_value == ""
                                                            ? [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger text-center",
                                                                    staticStyle: {
                                                                      height:
                                                                        "133.5px"
                                                                    },
                                                                    attrs: {
                                                                      colspan:
                                                                        "7"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                  Data belum sesuai\n                                "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : [
                                                                _c("td", {
                                                                  staticClass:
                                                                    "text-wrap",
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      _vm.marketplaceIcon(
                                                                        row.mp_id
                                                                      )
                                                                    )
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-left"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            row.store_link,
                                                                          target:
                                                                            "_blank"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            row.store_name
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-wrap"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            row.product_url,
                                                                          target:
                                                                            "_blank"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            row.product_name
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-right"
                                                                  },
                                                                  [
                                                                    row.product_price_start !=
                                                                    ""
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.formatPrice(
                                                                                  row.product_price_start
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    row.product_price_start !=
                                                                      "" &&
                                                                    row.product_price_end !=
                                                                      "" &&
                                                                    row.product_price_start <
                                                                      row.product_price_end
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "-\n                                    " +
                                                                                _vm._s(
                                                                                  _vm.formatPrice(
                                                                                    row.product_price_end
                                                                                  )
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-wrap"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            row.product_image1,
                                                                          target:
                                                                            "_blank"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "lazy",
                                                                                rawName:
                                                                                  "v-lazy",
                                                                                value:
                                                                                  row.product_image1,
                                                                                expression:
                                                                                  "row.product_image1"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "squared",
                                                                            staticStyle: {
                                                                              width:
                                                                                "100px"
                                                                            },
                                                                            attrs: {
                                                                              alt:
                                                                                ""
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-wrap"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            row.scraping_file_screenshot,
                                                                          target:
                                                                            "_blank"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "lazy",
                                                                                rawName:
                                                                                  "v-lazy",
                                                                                value:
                                                                                  row.scraping_file_screenshot,
                                                                                expression:
                                                                                  "row.scraping_file_screenshot"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "squared",
                                                                            staticStyle: {
                                                                              width:
                                                                                "100px"
                                                                            },
                                                                            attrs: {
                                                                              alt:
                                                                                ""
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-center"
                                                                  },
                                                                  [
                                                                    _c("div", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          _vm.monitoringStatusLabelStyle(
                                                                            row.status_value
                                                                          )
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  )
                                                : _vm.previewRows.length < 1 &&
                                                  !_vm.previewLoading
                                                ? [_vm._m(4)]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-md btn-light",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.clearForm($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-trash" }),
                                    _vm._v(" Reset\n                      ")
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-md btn-warning",
                                    style:
                                      "margin-left:10px; color: #fff; background-color: #ff9b44; border-color: #ff9b44;",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.addForm($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "la la-plus" }),
                                    _vm._v(" Add\n                      ")
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ],
                    2
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-form-label col-md-4" }, [
      _vm._v("Brand"),
      _c("span", { staticClass: "text text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-form-label col-md-4" }, [
      _vm._v("Product"),
      _c("span", { staticClass: "text text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("label", { staticClass: "col-md-12" }, [
        _vm._v("Import Link"),
        _c("span", { staticClass: "text text-danger" }, [_vm._v("*")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center" }, [_vm._v("Marketplace")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Username Toko")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Nama Produk")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Harga Produk")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Gambar Produk")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Screenshot")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Status")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "text-center", attrs: { colspan: "7" } }, [
        _vm._v(
          "\n                                -empty-\n                              "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d8066f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d8066f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/links/import.vue
// module id = null
// module chunks = 